import { motion } from "framer-motion";
import ContactForm from "@/components/ContactForm";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

const ContactPage = () => {
  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="py-24 bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">
              İLETİŞİM
            </p>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-slate-900 font-['Outfit'] mb-6">
              Sizinle tanışmak için <span className="text-gradient">çok heyecanlıyız!</span>
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Size yardımcı olabileceğimiz bir konu var mı? Hemen iletişime geçin.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Left - Info */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-8">
                Hemen <span className="text-gradient">başlayalım</span>
              </h2>

              <p className="text-lg text-slate-600 leading-relaxed mb-12">
                Ücretsiz analiz ve teklif için formu doldurun veya doğrudan bize ulaşın. 
                <strong> 1 saat içinde dönüş yapıyoruz.</strong>
              </p>

              {/* Contact Info Cards */}
              <div className="space-y-4 mb-12">
                <a
                  href="tel:+905413598024"
                  className="flex items-center gap-4 p-4 rounded-2xl bg-slate-50 hover:bg-slate-100 transition-colors group"
                >
                  <div className="p-3 rounded-xl bg-purple-100 text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-colors">
                    <Phone size={24} />
                  </div>
                  <div>
                    <p className="text-sm text-slate-500">Telefon</p>
                    <p className="font-semibold text-slate-900">0541 359 80 24</p>
                  </div>
                </a>

                <a
                  href="mailto:info@dijitalyukselis.com"
                  className="flex items-center gap-4 p-4 rounded-2xl bg-slate-50 hover:bg-slate-100 transition-colors group"
                >
                  <div className="p-3 rounded-xl bg-purple-100 text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-colors">
                    <Mail size={24} />
                  </div>
                  <div>
                    <p className="text-sm text-slate-500">E-posta</p>
                    <p className="font-semibold text-slate-900">info@dijitalyukselis.com</p>
                  </div>
                </a>

                <div className="flex items-center gap-4 p-4 rounded-2xl bg-slate-50">
                  <div className="p-3 rounded-xl bg-purple-100 text-purple-600">
                    <MapPin size={24} />
                  </div>
                  <div>
                    <p className="text-sm text-slate-500">Konum</p>
                    <p className="font-semibold text-slate-900">Türkiye</p>
                  </div>
                </div>
              </div>

              {/* WhatsApp CTA */}
              <a
                href="https://wa.me/905413598024?text=Merhaba,%20hizmetleriniz%20hakkında%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#22c55e] text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                data-testid="whatsapp-contact-button"
              >
                <MessageCircle size={24} />
                WhatsApp'tan Yazın
              </a>
            </motion.div>

            {/* Right - Form */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <ContactForm title="Bize Ulaşın" />
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
